import { render, staticRenderFns } from "./NotificationBubble.vue?vue&type=template&id=925fe782&scoped=true&"
import script from "./NotificationBubble.vue?vue&type=script&lang=js&"
export * from "./NotificationBubble.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBubble.vue?vue&type=style&index=0&id=925fe782&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925fe782",
  null
  
)

export default component.exports